import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'

import { AppearanceColors } from '../../Editor/Appearance/AppearanceColors.js'

export function AppearanceColorsRoute() {
  return (
    <Sidebar size="lg">
      <Sidebar.Content className="space-y-4">
        <AppearanceColors />
      </Sidebar.Content>
    </Sidebar>
  )
}

export function AppearanceColorsBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.design.appearance.colors}>
      <T id="Generics.Colors" defaultMessage="Colors" />
    </Link>
  )
}
